<circ-loader [isLoading]="loading">
  <div *ngIf="step">
    <div>
      {{ title }} {{ 'step_details_forward' | i18n }}
    </div>
    <form class="k-form" [formGroup]="form">
      <fieldset class="k-form-fieldset">
        <kendo-formfield showErrors="initial">
          <kendo-label [for]="responsible" [text]="'step_details_responsible' | i18n"></kendo-label>
          <sp-people-picker #responsible [maxPeople]="1" formControlName="responsible">
          </sp-people-picker>
          <kendo-formerror>
            <div *ngIf="form.controls.responsible.errors?.required">
              {{'step_forward_formerror_responsible' | i18n }}
            </div>
            <div *ngIf="form.controls.responsible.errors?.singleSelection">
              {{ 'step_forward_formerror_tooManyPeople'  | i18n }}
            </div>
          </kendo-formerror>
        </kendo-formfield>
        <kendo-formfield>
          <kendo-label [for]="comment" [text]=" 'step_forward_label_comment' | i18n "></kendo-label>
          <textarea kendoTextArea formControlName="comment" #comment [autoSize]="true"></textarea>
        </kendo-formfield>
        <div class="k-form-buttons">
          <ece-btn-primary (click)="save()" [text]=" 'step_forward_button_save' | i18n"></ece-btn-primary>
          <ece-btn (click)="abort()" [text]=" 'step_forward_button_abort' | i18n"></ece-btn>
        </div>
      </fieldset>
    </form>
  </div>
</circ-loader>
